/// <reference types="vite-plugin-svgr/client" />

import icons, { IconType } from './icon.type';
import { memo } from 'react';

type Props = {
  type: IconType;
  width?: string | number;
  height?: string | number;
  fill?: string;
  stroke?: string;
  rotate?: string;
  className?: string;
  onClick?: () => void;
};

export const Icon = memo(
  ({
    type,
    width,
    height,
    fill = 'transparent',
    stroke,
    rotate = '0',
    className,
    onClick,
  }: Props) => {
    const IconComponent = icons[type];

    if (!IconComponent) {
      return null;
    }

    return (
      <IconComponent
        width={width}
        height={height}
        fill={fill}
        stroke={stroke}
        style={{ transform: `rotate(${rotate}deg)` }}
        onClick={onClick}
        className={className}
      />
    );
  },
);

export { IconType };
